import { ImageResponsive } from '@/components/commons/images/ImageResponsive.component'
import { Text } from '@/components/commons/typography/Text'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import { colorsV2 } from '@/styles/v2/vars/vars.colors'
import { Button } from '@mantine/core'
import { useIsProfileFreebirdEligible } from 'containers/profile/hooks/useFreebirdProfile'
import { useIsOwnProfile } from 'containers/profile/hooks/useProfile'
import { useUser } from 'containers/user/hooks/useUser'
import Link from 'next/link'
import { EXTERNAL_LINKS } from 'utilities/links'

export const SuperchargeCard = () => {
  const { user } = useUser()
  const ownProfile = useIsOwnProfile()
  const isFreebirdElegible = useIsProfileFreebirdEligible()

  const linkApply = isFreebirdElegible
    ? EXTERNAL_LINKS.NETWORK_BUILDER_SERVICE_APPLY
    : EXTERNAL_LINKS.SUPERCHARGE_TYPEFORM

  if (ownProfile && isFreebirdElegible) {
    return (
      <div className="bg-white-primary rounded-18 p-24 flex flex-column gap-14 items-center justify-center">
        <Text
          as="h2"
          sizeClass="text-16"
          colorClass="text-black"
          weightClass="font-bold"
        >
          Automate{' '}
          <Text
            as="span"
            className="italic"
            colorClass="text-info"
            weightClass="font-bold"
          >
            Your Creator Recruiting!
          </Text>
        </Text>

        <Text
          variation="xSmall"
          className="text-center"
          colorClass="text-tertirary"
        >
          Creatorland PRO lets you put your recruiting roster building, and
          creator advertising efforts on autopilot!{' '}
          <span className="font-bold">No annual commitment required!</span>
        </Text>

        <div className="full-w">
          <ImageResponsive
            src={IMAGE_PATHS_V2.profileV2 + 'creator-recruiting-card.png'}
            alt="Automate Your Creator Recruiting"
            sizes="335px"
            className="full-w"
          />
        </div>
        <div className="flex gap-12 full-w">
          <Link href="/checkout" passHref className="flex-1">
            <Button
              variant="filled"
              bg={colorsV2.accent.light.primary}
              c="black"
              fw="bold"
              tt="uppercase"
              radius={10}
              fullWidth
            >
              Become a PRO
            </Button>
          </Link>

          <Link
            href={EXTERNAL_LINKS.AUTOMATE_RECRUITING}
            passHref
            target="_blank"
            className="flex-1"
          >
            <Button
              variant="outline"
              color={colorsV2.stroke.light.secondary}
              c="black"
              fw="bold"
              tt="uppercase"
              radius={10}
              fullWidth
            >
              Learn More
            </Button>
          </Link>
        </div>
      </div>
    )
  }

  return null
}
